import { createSvgComponent } from "../../../icon/createSvgComponent";
import MagnifyingGlass from "../figma/magnifying-glass.svg";
export default createSvgComponent(MagnifyingGlass);